import { CreateInsuranceProperties } from '../../../redux/API/ClientAPIHelpers/insuranceProperties';

export const ACTIONS = {
	setState: 'setState',
	setName: 'SET_NAME',
	setTimelyFiling: 'SET_TIMELY_FILING',
	setAgeLimit: 'SET_AGE_LIMIT',
	setMinBillableMinutes: 'SET_MIN_BILLABLE_MINUTES',
	setIsActive: 'SET_ISACTIVE',
	setCanBeAssigned: 'SET_CANBEASSIGNED',
	setIsOutOfNetwork: 'SET_ISOUTOFNETWORK',
	setOpenAuth: 'SET_OPENAUTH',
	setAllowedLbaWithoutBcba: 'SET_ALLOWEDLBAWITHOUTBCBA',
	setTwoBcbaCanBillAtSameDay: 'SET_TWOBCBACANBILLATSAMEDAY',
	setLimitedBcbasBillAsNotCredentialed: 'SET_LIMITEDBCBASBILLASNOTCREDENTIALED',
	setAllowTelehealthForAssessment: 'SET_ALLOWTELEHEALTHFORASSESSMENT',
	setAllowTelehealthForBTM: 'SET_ALLOWTELEHEALTHFORBTM',
	setParentId: 'SET_PARENT_ID',
} as const;

export interface ActionProperties {
	payload: any;

	type: string;
}

export const insuranceReducer = (
	state: Partial<CreateInsuranceProperties>,
	action: ActionProperties,
): Partial<CreateInsuranceProperties> => {
	switch (action.type) {
		case ACTIONS.setState:
			return { ...state, ...action.payload };
		case ACTIONS.setName:
			return { ...state, name: action.payload };
		case ACTIONS.setTimelyFiling:
			return { ...state, timelyFilingForClaims: action.payload };
		case ACTIONS.setAgeLimit:
			return { ...state, ageLimit: action.payload };
		case ACTIONS.setMinBillableMinutes:
			return { ...state, minimumBillableMinutesPerDay: action.payload };
		case ACTIONS.setIsActive:
			return { ...state, isActive: action.payload };
		case ACTIONS.setCanBeAssigned:
			return { ...state, canBeAssigned: action.payload };
		case ACTIONS.setIsOutOfNetwork:
			return { ...state, isOutOfNetwork: action.payload };
		case ACTIONS.setOpenAuth:
			return { ...state, openAuth: action.payload };
		case ACTIONS.setAllowedLbaWithoutBcba:
			return { ...state, allowedLbaWithoutBcba: action.payload };
		case ACTIONS.setTwoBcbaCanBillAtSameDay:
			return { ...state, twoBcbaCanBillAtSameDay: action.payload };
		case ACTIONS.setLimitedBcbasBillAsNotCredentialed:
			return { ...state, limitedBcbasBillAsNotCredentialed: action.payload };
		case ACTIONS.setAllowTelehealthForAssessment:
			return { ...state, allowTelehealthForAssessment: action.payload };
		case ACTIONS.setAllowTelehealthForBTM:
			return { ...state, allowTelehealthForBTM: action.payload };
		case ACTIONS.setParentId:
			return { ...state, parentId: action.payload };
		default:
			return state;
	}
};

export const initialInsuranceState: Partial<CreateInsuranceProperties> = {
	name: '',
	isActive: true,
	canBeAssigned: true,
	isOutOfNetwork: false,
	timelyFilingForClaims: 0,
	ageLimit: 0,
	minimumBillableMinutesPerDay: undefined,
	allowedLbaWithoutBcba: false,
	twoBcbaCanBillAtSameDay: false,
	limitedBcbasBillAsNotCredentialed: false,
	openAuth: false,
	allowTelehealthForAssessment: false,
	allowTelehealthForBTM: false,
	branchIds: [],
};
